var map = {
	"./digital_print.jpg": 7433,
	"./digital_print1.jpg": 1821,
	"./digital_print2.jpg": 2590,
	"./digital_print3.jpg": 8424,
	"./digital_print4.jpg": 7299,
	"./gallery1.jpg": 471,
	"./gallery2.jpg": 1069,
	"./gallery3.jpg": 841,
	"./galvanic.jpg": 1312,
	"./galvanic1.jpg": 4604,
	"./galvanic2.jpg": 9713,
	"./laser_engraving.jpg": 9746,
	"./laser_engraving1.jpg": 846,
	"./laser_engraving2.jpg": 465,
	"./laser_engraving3.jpg": 8531,
	"./out_sourcing.3.jpg": 2148,
	"./out_sourcing.jpg": 2423,
	"./out_sourcing1.jpg": 6805,
	"./out_sourcing2.jpg": 1123,
	"./out_sourcing3.jpg": 3615,
	"./out_sourcing4.jpg": 3362,
	"./packing.jpg": 3310,
	"./packing1.jpg": 6490,
	"./packing2.jpg": 8722,
	"./packing3.jpg": 6462,
	"./painting.jpg": 6302,
	"./painting1.jpg": 8345,
	"./painting2.jpg": 6099,
	"./painting3.jpg": 1352,
	"./painting4.jpg": 2793,
	"./painting5.jpg": 2438,
	"./painting6.jpg": 3795,
	"./sublimation.jpg": 590,
	"./sublimation1.jpg": 1012,
	"./sublimation2.jpg": 5160,
	"./sublimation3.jpg": 6579,
	"./sublimation4.jpg": 6563,
	"./sublimation5.jpg": 4686
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6052;